module.exports = __webpack_public_path__ + "static/heroMaestros-a4094f94fbddf6d81cdb88e3f40aa141.png";